module.exports = __webpack_public_path__ + "static/media/logo.8e8b8833.png";